import {VulgarismList} from "~/config/VulgarismList";

export const useTextHelper = () => {
  const config = useRuntimeConfig()
  const vulgarismReplacementChar = String(config?.public?.vulgarismReplacementChar || '.')

  const escapeRegExp = (str: string): string => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  const removeVulgarisms = (name?: string): string | undefined => {
    let result = name
    if (!result) {
      return result
    }

    for (const word of VulgarismList) {
      if (!word) continue;

      const escapedWord = escapeRegExp(word)
      const regex = new RegExp(escapedWord, "gi") // i = ignoring letter size

      result = result.replace(regex, (match) => {
        const firstTwo = match.slice(0, 2) // took 2 first chars from original string
        const dots = vulgarismReplacementChar.repeat(Math.max(0, word.length - 2))
        return firstTwo + dots
      });
    }

    return result;
  }

  return {
    removeVulgarisms
  }
}


